import { render, staticRenderFns } from "./fccSituacao.vue?vue&type=template&id=6298c38b"
import script from "./fccSituacao.vue?vue&type=script&lang=js"
export * from "./fccSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports